<template>
  <div v-if="rate != 0">
    <h6>💱 汇率</h6>
    <div>
      <b-input-group size="sm" title="美元">
        <b-input-group-text slot="append"
          ><span style="width:1em;">$</span></b-input-group-text
        >
        <b-form-input
          v-model="dollarValue"
          @input="changeDollar"
          type="number"
          class="form-control input-sm"
          placeholder="美元"
        ></b-form-input>
      </b-input-group>
      <div class="text-center">
        ↕
      </div>
      <b-input-group size="sm" title="人民币">
        <b-input-group-text slot="append"
          ><span style="width:1em;">￥</span></b-input-group-text
        >
        <b-form-input
          v-model="rmbValue"
          @input="changeRmb"
          type="number"
          class="form-control input-sm"
          placeholder="人民币"
        ></b-form-input>
      </b-input-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rate: 0,
      rmbValue: 1,
      dollarValue: 1
    };
  },
  mounted: function() {
    this.getRate();
    setInterval(this.getRate, 43200000);
  },
  methods: {
    changeDollar: function() {
      this.rmbValue = (this.dollarValue * this.rate).toFixed(4);
    },
    changeRmb: function() {
      if (this.rate === 0) {
        this.dollarValue = 0;
        return;
      }
      this.dollarValue =
        this.rate === 0 ? 0 : (this.rmbValue / this.rate).toFixed(4);
    },
    getRate: function() {
      this.$axios.get("/rate").then(resp => {
        this.rate = resp.data;
        this.changeDollar();
      });
    }
  }
};
</script>
